import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=0fde07bc&scoped=true"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fde07bc",
  null
  
)

export default component.exports